import { motion } from 'framer-motion'
import { useState, useEffect } from 'react'

export function Hero() {
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
        delayChildren: 0.2
      }
    }
  }

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        type: 'spring',
        damping: 12,
        stiffness: 100
      }
    }
  }

  return (
    <section id="home" className="min-h-screen flex items-center justify-center relative overflow-hidden w-full">
      {/* DANIELEGRIECO Logo in top-left */}
      <div className="absolute top-6 left-6 z-20">
        <h1 className="text-2xl md:text-3xl font-light text-[#22c55e] tracking-wider">
          DANIELEGRIECO
        </h1>
      </div>

      {/* Moving Skills Strip */}
      <motion.div
        className="fixed top-1/2 left-0 right-0 transform -translate-y-1/2 z-10 hidden"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
      >
        <div className="flex items-center justify-center">
            <motion.div
              className="flex items-center gap-8 text-white text-lg font-semibold whitespace-nowrap"
              animate={{
                x: ["0px", "-50%"],
              }}
              transition={{
                duration: 20,
                repeat: Infinity,
                ease: "linear"
              }}
            >
              {/* Digital Design */}
              <div className="flex items-center gap-4 px-6 py-3">
                <span className="text-gray-300">DIGITAL DESIGN</span>
                <div className="w-px h-8 bg-white/30 mx-4" />
              </div>
              
              {/* UX-UI */}
              <div className="flex items-center gap-4 px-6 py-3">
                <span className="text-gray-300">UX-UI</span>
                <div className="w-px h-8 bg-white/30 mx-4" />
              </div>
              
              {/* Art Direction */}
              <div className="flex items-center gap-4 px-6 py-3">
                <span className="text-gray-300">ART DIRECTION</span>
                <div className="w-px h-8 bg-white/30 mx-4" />
              </div>
              
              {/* 3D */}
              <div className="flex items-center gap-4 px-6 py-3">
                <span className="text-gray-300">3D</span>
                <div className="w-px h-8 bg-white/30 mx-4" />
              </div>
              
              {/* Motion */}
              <div className="flex items-center gap-4 px-6 py-3">
                <span className="text-gray-300">MOTION</span>
                <div className="w-px h-8 bg-white/30 mx-4" />
              </div>
              
              {/* Web Design */}
              <div className="flex items-center gap-4 px-6 py-3">
                <span className="text-gray-300">WEBDESIGN</span>
                <div className="w-px h-8 bg-white/30 mx-4" />
              </div>
              
              {/* Photography */}
              <div className="flex items-center gap-4 px-6 py-3">
                <span className="text-gray-300">PHOTOGRAPHY</span>
                <div className="w-px h-8 bg-white/30 mx-4" />
              </div>
              
              {/* AI Friends */}
              <div className="flex items-center gap-4 px-6 py-3">
                <span className="text-gray-300">AI FRIENDS</span>
                <div className="w-px h-8 bg-white/30 mx-4" />
              </div>
              
              {/* Marketing */}
              <div className="flex items-center gap-4 px-6 py-3">
                <span className="text-gray-300">MARKETING</span>
                <div className="w-px h-8 bg-white/30 mx-4" />
              </div>
              
              {/* B2B */}
              <div className="flex items-center gap-4 px-6 py-3">
                <span className="text-gray-300">B2B</span>
                <div className="w-px h-8 bg-white/30 mx-4" />
              </div>
              
              {/* Duplicate for seamless infinite loop */}
              <div className="flex items-center gap-4 px-6 py-3">
                <span className="text-gray-300">DIGITAL DESIGN</span>
                <div className="w-px h-8 bg-white/30 mx-4" />
              </div>
              
              <div className="flex items-center gap-4 px-6 py-3">
                <span className="text-gray-300">UX-UI</span>
                <div className="w-px h-8 bg-white/30 mx-4" />
              </div>
              
              <div className="flex items-center gap-4 px-6 py-3">
                <span className="text-gray-300">ART DIRECTION</span>
                <div className="w-px h-8 bg-white/30 mx-4" />
              </div>
              
              <div className="flex items-center gap-4 px-6 py-3">
                <span className="text-gray-300">3D</span>
                <div className="w-px h-8 bg-white/30 mx-4" />
              </div>
              
              <div className="flex items-center gap-4 px-6 py-3">
                <span className="text-gray-300">MOTION</span>
                <div className="w-px h-8 bg-white/30 mx-4" />
              </div>
              
              <div className="flex items-center gap-4 px-6 py-3">
                <span className="text-gray-300">WEBDESIGN</span>
                <div className="w-px h-8 bg-white/30 mx-4" />
              </div>
              
              <div className="flex items-center gap-4 px-6 py-3">
                <span className="text-gray-300">PHOTOGRAPHY</span>
                <div className="w-px h-8 bg-white/30 mx-4" />
              </div>
              
              <div className="flex items-center gap-4 px-6 py-3">
                <span className="text-gray-300">AI FRIENDS</span>
                <div className="w-px h-8 bg-white/30 mx-4" />
              </div>
              
              <div className="flex items-center gap-4 px-6 py-3">
                <span className="text-gray-300">MARKETING</span>
                <div className="w-px h-8 bg-white/30 mx-4" />
              </div>
              
              <div className="flex items-center gap-4 px-6 py-3">
                <span className="text-gray-300">B2B</span>
                <div className="w-px h-8 bg-white/30 mx-4" />
              </div>
              
              {/* Third set for extra safety in infinite loop */}
              <div className="flex items-center gap-4 px-6 py-3">
                <span className="text-gray-300">DIGITAL DESIGN</span>
                <div className="w-px h-8 bg-white/30 mx-4" />
              </div>
              
              <div className="flex items-center gap-4 px-6 py-3">
                <span className="text-gray-300">UX-UI</span>
                <div className="w-px h-8 bg-white/30 mx-4" />
              </div>
              
              <div className="flex items-center gap-4 px-6 py-3">
                <span className="text-gray-300">ART DIRECTION</span>
                <div className="w-px h-8 bg-white/30 mx-4" />
              </div>
              
              <div className="flex items-center gap-4 px-6 py-3">
                <span className="text-gray-300">3D</span>
                <div className="w-px h-8 bg-white/30 mx-4" />
              </div>
              
              <div className="flex items-center gap-4 px-6 py-3">
                <span className="text-gray-300">MOTION</span>
                <div className="w-px h-8 bg-white/30 mx-4" />
              </div>
              
              <div className="flex items-center gap-4 px-6 py-3">
                <span className="text-gray-300">WEBDESIGN</span>
                <div className="w-px h-8 bg-white/30 mx-4" />
              </div>
              
              <div className="flex items-center gap-4 px-6 py-3">
                <span className="text-gray-300">PHOTOGRAPHY</span>
                <div className="w-px h-8 bg-white/30 mx-4" />
              </div>
              
              <div className="flex items-center gap-4 px-6 py-3">
                <span className="text-gray-300">AI FRIENDS</span>
                <div className="w-px h-8 bg-white/30 mx-4" />
              </div>
              
              <div className="flex items-center gap-4 px-6 py-3">
                <span className="text-gray-300">MARKETING</span>
                <div className="w-px h-8 bg-white/30 mx-4" />
              </div>
              
              <div className="flex items-center gap-4 px-6 py-3">
                <span className="text-gray-300">B2B</span>
                <div className="w-px h-8 bg-white/30 mx-4" />
              </div>
            </motion.div>
        </div>
      </motion.div>


      <div className="w-full text-center relative z-10 px-4">
        <motion.div
          className="max-w-4xl mx-auto"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          {/* DANIELEGRIECO removed as requested */}
        </motion.div>
      </div>
    </section>
  )
}
